import { apiSlice } from "../../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Section", "SubSection", "Template"],
});

export const sectionsApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getSection: builder.query({
      query: (parameter) => `/section/${parameter}`,
      providesTags: ["Section"],
    }),
    getSectionsPaginated: builder.query({
      query: ({ page = 1, per_page = 20, q = "" } = {}) => ({
        url: `/section/all`,
        params: { page, per_page, ...(q ? { q } : {}) },
      }),
      providesTags: ["Section"],
    }),
    getSubSection: builder.query({
      query: (parameter) => `section/subsection/${parameter}`,
      providesTags: ["SubSection"],
    }),
    getSubSectionsPaginated: builder.query({
      query: ({ page = 1, per_page = 20, q = "" } = {}) => ({
        url: `/section/subsection/all`,
        params: { page, per_page, ...(q ? { q } : {}) },
      }),
      providesTags: ["SubSection"],
    }),
    createSection: builder.mutation({
      query: (values) => ({
        url: "/section/create",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Section"],
    }),
    updateSection: builder.mutation({
      query: (values) => ({
        url: "/section/update",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Section"],
    }),
    deleteSection: builder.mutation({
      query: (values) => ({
        url: `/section/${values.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Section"],
    }),
    createSubSection: builder.mutation({
      query: (values) => ({
        url: "/section/subsection/create",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["SubSection", "Section"],
    }),
    updateSubSection: builder.mutation({
      query: (values) => ({
        url: "/section/subsection/update",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["SubSection", "Section"],
    }),
    addTemplateToSubSection: builder.mutation({
      query: (values) => ({
        url: "/section/subsection/add-template",
        method: "PATCH",
        body: { ...values },
      }),
      invalidatesTags: ["SubSection", "Section"],
    }),
    removeTemplate: builder.mutation({
      query: (values) => ({
        url: "/section/subsection/remove-template",
        method: "PATCH",
        body: { ...values },
      }),
      invalidatesTags: ["SubSection", "Section"],
    }),
    deleteSubSection: builder.mutation({
      query: (values) => ({
        url: `/section/subsection/${values.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["SubSection", "Section"],
    }),
    getTemplates: builder.query({
      query: (parameter) => `/template/${parameter}`,
      providesTags: ["Template"],
    }),
    getTemplatesPaginated: builder.query({
      query: ({ page = 1, per_page = 20, q = "" } = {}) => ({
        url: `/template/all`,
        params: { page, per_page, ...(q ? { q } : {}) },
      }),
      providesTags: ["Template"],
    }),
    previewTemplate: builder.query({
      query: (id) => ({
        url: `/template/${id}/preview`,
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const {
  useCreateSectionMutation,
  useCreateSubSectionMutation,
  useGetSectionQuery,
  useGetSectionsPaginatedQuery,
  useGetSubSectionQuery,
  useGetSubSectionsPaginatedQuery,
  useUpdateSectionMutation,
  useUpdateSubSectionMutation,
  useDeleteSectionMutation,
  useDeleteSubSectionMutation,
  useAddTemplateToSubSectionMutation,
  useRemoveTemplateMutation,
  useGetTemplatesQuery,
  useGetTemplatesPaginatedQuery,
  usePreviewTemplateQuery,
} = sectionsApiSlice;
